import React, { useState, useEffect, useCallback } from 'react';

const MODAL_DELAY = 20000;

const ShowModalTrigger = ({ children, onTrigger }) => {
  const [triggered, setTriggered] = useState(false);
  const [waiting, setWaiting] = useState(false);
  const isBrowser = typeof window !== 'undefined';

  const handleScroll = useCallback(() => {
    const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
    const scrollPosition = scrollTop + clientHeight;
    const scrollPercentage = (scrollPosition / scrollHeight) * 100;

    if (scrollPercentage >= 75 && !triggered && !waiting && isBrowser) {
      setWaiting(true);

      setTimeout(() => {
        setWaiting(false);
        setTriggered(true);
        onTrigger();
      }, MODAL_DELAY);
    }
  }, [triggered, onTrigger, waiting, isBrowser]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!triggered && isBrowser) {
        setTriggered(true);
        onTrigger();
      }
    }, MODAL_DELAY);

    return () => clearTimeout(timer);
  }, [triggered, onTrigger, isBrowser]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  return <div>{children}</div>;
};

export default ShowModalTrigger;
